// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"6afbd6af6e77e4228198","731":"2b0a15b0d724e36eafd1","843":"d05a29d6be69d7e791c5","883":"2cb0075b2e5a7cbe1771"}[chunkId] + ".js";
};